import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentLanguage: localStorage.getItem('appLanguage') || 'zh-CN'
  },
  getters: {
    getCurrentLanguage: state => state.currentLanguage
  },
  mutations: {
    SET_LANGUAGE(state, lang) {
      state.currentLanguage = lang;
      localStorage.setItem('appLanguage', lang); // 持久化到localStorage
    }
  },
  actions: {
    changeLanguage({ commit }, lang) {
      commit('SET_LANGUAGE', lang);
    },
    initLanguage({ commit }) {
      const savedLang = localStorage.getItem('appLanguage');
      if (savedLang) {
        commit('SET_LANGUAGE', savedLang);
      }
    }
  },
  modules: {
  }
})
